import SwimmingPoolSvg from "@assets/images/svg/swimming-pool.svg";
import React from "react";
import { View } from "react-native";

export interface SwimmingPoolIconProps {
  size?: number;
  color?: string;
}

export function SwimmingPoolIcon({
  size = 24,
  color = "#4D4D4D",
}: SwimmingPoolIconProps) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <SwimmingPoolSvg width={size} height={size} color={color} />
    </View>
  );
}

export default SwimmingPoolIcon;
